// import axios from '@/utilities/service/httpClient'
// import Configuration from '@/utilities/service/Configuration'

// const apiHost = Configuration.value('apiHost')

export default {}
